import { useState } from "react";
import { PAISES, DOC_TIPOS } from "../../lib/kycData";
import { rutValido, formatRut } from "../../lib/format";
import { TextIn, SelectIn, Group } from "./FormBits";
import { BigButton, StepTitle } from "./KycShell";

const PAIS_OPTS = PAISES.map((p) => [p.code, p.name]);
const SEXO = [["F", "Femenino"], ["M", "Masculino"]];
const INIT = { nombres: "", apellido_paterno: "", apellido_materno: "", fecha_nacimiento: "", nacionalidad: "", sexo: "", documento_tipo: "", documento_otro: "", documento_numero: "", documento_vencimiento: "" };

export const StepManual = ({ brand, onSubmit, busy }) => {
  const [f, setF] = useState(INIT);
  const b = (k) => ({ value: f[k], onChange: (e) => setF({ ...f, [k]: e.target.value }) });
  const runMal = f.documento_tipo === "run_chile" && f.documento_numero.length > 3 && !rutValido(f.documento_numero);
  const nul = (x) => x || null;
  const submit = (e) => {
    e.preventDefault();
    onSubmit({ ...f, apellido_materno: nul(f.apellido_materno), documento_otro: nul(f.documento_otro), sexo: nul(f.sexo) });
  };
  return (
    <form onSubmit={submit} className="space-y-5" data-testid="kyc-step-manual">
      <StepTitle paso="" title="Escribe los datos de tu documento">No pudimos leer tu documento con la cámara. Escribe los datos tal como aparecen en él. La empresa los revisará.</StepTitle>
      <Group title="Quién eres">
        <TextIn id="nombres" label="Nombres" required {...b("nombres")} />
        <TextIn id="apellido-paterno" label="Apellido paterno" required {...b("apellido_paterno")} />
        <TextIn id="apellido-materno" label="Apellido materno (si tienes)" {...b("apellido_materno")} />
        <TextIn id="fecha-nacimiento" label="Fecha de nacimiento" type="date" required {...b("fecha_nacimiento")} />
        <SelectIn id="nacionalidad" label="Nacionalidad" required options={PAIS_OPTS} {...b("nacionalidad")} />
        <SelectIn id="sexo" label="Sexo" options={SEXO} {...b("sexo")} />
      </Group>
      <Group title="Tu documento">
        <SelectIn id="documento-tipo" label="Tipo de documento" required options={DOC_TIPOS} {...b("documento_tipo")} />
        {f.documento_tipo === "otro" && <TextIn id="documento-otro" label="¿Qué documento es?" required {...b("documento_otro")} />}
        <TextIn id="documento-numero" label="Número de documento" required autoCapitalize="characters"
          value={f.documento_numero} onChange={(e) => setF({ ...f, documento_numero: e.target.value.toUpperCase() })}
          onBlur={() => f.documento_tipo === "run_chile" && rutValido(f.documento_numero) && setF({ ...f, documento_numero: formatRut(f.documento_numero) })} />
        {runMal && <p className="text-base text-rose-700" data-testid="kyc-run-error">El RUN no es válido. Revisa el dígito verificador.</p>}
        <TextIn id="documento-vencimiento" label="Fecha de vencimiento" type="date" required {...b("documento_vencimiento")} />
      </Group>
      <BigButton type="submit" color={brand.color} disabled={busy || runMal} data-testid="manual-continue-button">Continuar</BigButton>
    </form>
  );
};
